import { render, staticRenderFns } from "./spin.vue?vue&type=template&id=2980d9fa"
import script from "./spin.vue?vue&type=script&lang=js"
export * from "./spin.vue?vue&type=script&lang=js"
import style0 from "./spin.vue?vue&type=style&index=0&id=2980d9fa&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports